import React from "react";
import { Col, Row } from "react-bootstrap";
import "../../Assets/Styles/pages/imageProperties.scss";
import { useTranslation } from "react-i18next";
import { EnumAlign } from "../../Config/config";
import topLeft from "../../Assets/Images/topLeft.svg";
import topCenter from "../../Assets/Images/topCenter.svg";
import topRight from "../../Assets/Images/topRight.svg";
import center from "../../Assets/Images/center.svg";
import bottomLeft from "../../Assets/Images/bottomLeft.svg";
import bottomCenter from "../../Assets/Images/bottomCenter.svg";
import bottomRight from "../../Assets/Images/bottomRight.svg";

const AlignmentRow = ({ alignItem }) => {
  const { t } = useTranslation();

  return (
    <Col className="alignment_wrapper my-3 mx-2 py-1">
      <Row className="productSansLight text_15 m-0 mb-2">
        <Row className="m-0 p-0">{t("ImageProps.Alignment")}</Row>
      </Row>
      <img
        alt="top left"
        src={topLeft}
        className="alignment pointer"
        onClick={() => alignItem(EnumAlign.TopLeft)}
      />
      <img
        alt="top center"
        src={topCenter}
        className="alignment pointer"
        onClick={() => alignItem(EnumAlign.TopCenter)}
      />
      <img
        alt="top right"
        src={topRight}
        className="alignment pointer"
        onClick={() => alignItem(EnumAlign.TopRight)}
      />
      <img
        alt="center"
        src={center}
        className="alignment pointer"
        onClick={() => alignItem(EnumAlign.Center)}
      />
      <img
        alt="bottom left"
        src={bottomLeft}
        className="alignment pointer"
        onClick={() => alignItem(EnumAlign.BottomLeft)}
      />
      <img
        alt="bottom center"
        src={bottomCenter}
        className="alignment pointer"
        onClick={() => alignItem(EnumAlign.BottomCenter)}
      />
      <img
        alt="bottom right"
        src={bottomRight}
        className="alignment pointer"
        onClick={() => alignItem(EnumAlign.BottomRight)}
      />
    </Col>
  );
};

export default AlignmentRow;
